import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { Cradle } from '@solo/app-core';
import { Text, Flex, LoadingComponent } from '@/app/ui';
import SignaturitComponent from '@/app/ui/organisms/SignUp/Signaturit/SignaturitComponent';
import Colors from '@/app/styles/Colors';
import { useCradle } from '@/app/contexts';

const SignaturitComponentStyled = styled(SignaturitComponent)`
  width: 100%;
  padding: 0;
  h2 {
    color: ${Colors.black} !important;
  }

  .signaturit-card {
    background-color: rgb(250, 250, 250);

    div {
      height: 100% !important;
      overflow-y: hidden !important;
      max-width: 100% !important;
    }
  }
`;

const ContractsComponent = () => {
  const { authBloc } = useCradle<Cradle>();
  const [loading, setLoading] = useState(true);

  const getContracts = async () => {
    await authBloc.getContractsMe();
  };

  useEffect(() => {
    setLoading(true);
    getContracts();
  }, []);

  return (
    <div>
      <Text.PageTitle>Contracts</Text.PageTitle>
      <Flex.Container className="mb-5">
        {loading ? <LoadingComponent /> : <SignaturitComponentStyled nextStep={() => {}} />}
      </Flex.Container>
    </div>
  );
};

export default ContractsComponent;
